import { createFormControl, useFormState } from 'react-hook-form';
import { CollateralFormDataValues } from './schema';
import { useMemo } from 'react';
import { useCollateralFormOnSubmitFactory } from './onSubmit';

const formControls: Record<
  string,
  ReturnType<typeof createFormControl<CollateralFormDataValues>>
> = {};

export const getCollateralFormContext = (applicationID: string) => {
  if (!formControls[applicationID])
    formControls[applicationID] = createFormControl();

  return formControls[applicationID];
};

export const useCollateralFormContext = (applicationID: string) => {
  const formContext = getCollateralFormContext(applicationID);
  const submit = useCollateralFormOnSubmitFactory({
    applicationID,
    formContext,
  });

  const formState = useFormState({ control: formContext.control });

  return useMemo(
    () => ({
      ...formContext,
      formState,
      handleSubmit: undefined,
      submit,
    }),
    [formContext, submit, formState],
  );
};
